import type { ReactNode } from "react";
import { TbArrowLeft } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import CarePlusShippingFAQ from "../../CarePlusShared/CarePlusShippingFAQ";
import CarePlusStepper from "../../CarePlusShared/CarePlusStepper";
import { Translate } from "../../ChoosePlanCarePlus/planContent";
import "./PaymentV3CarePlus.css";

// The V3 shell owns only Figma composition. PaymentPage stays the data and interaction owner.

interface PaymentV3CarePlusProps {
  t: Translate;
  trustBar: ReactNode;
  paymentOptions: ReactNode;
  cartSummary: ReactNode;
  costBreakdown: ReactNode;
  cta: ReactNode;
  onOpenCostBreakdown: () => void;
  /** False hides the Care+ FAQ (the UK funnel has no Care+). */
  showFaq?: boolean;
}

const PaymentV3CarePlus = ({
  t,
  trustBar,
  paymentOptions,
  cartSummary,
  costBreakdown,
  cta,
  onOpenCostBreakdown,
  showFaq = true,
}: PaymentV3CarePlusProps) => {
  const navigate = useNavigate();

  return (
    <section className="payment-v3-care-plus" aria-label={t("payment", "Payment")}>
      <div className="payment-v3-care-plus__progress" aria-label="Checkout progress">
        <button type="button" className="payment-v3-care-plus__back" aria-label="Back" onClick={() => navigate(-1)}>
          <TbArrowLeft size={22} aria-hidden="true" />
        </button>
        <div className="payment-v3-care-plus__stepper">
          <CarePlusStepper current="checkout" t={t} compact variant="white" />
        </div>
      </div>

      <h1 className="payment-v3-care-plus__title">{t("payment", "Payment")}</h1>

      <div className="payment-v3-care-plus__content">
        <div className="payment-v3-care-plus__trust-bar">{trustBar}</div>
        <div className="payment-v3-care-plus__options">
          <p className="payment-v3-care-plus__options-title">{t("payment_options", "Payment options")}</p>
          {paymentOptions}
          <button type="button" className="payment-v3-care-plus__breakdown-link" onClick={onOpenCostBreakdown}>
            {t("breakdown_costs_link", "See the cost breakdown")}
          </button>
        </div>
        <div className="payment-v3-care-plus__cta">{cta}</div>
        <div className="payment-v3-care-plus__summary">{cartSummary}</div>
        <div className="payment-v3-care-plus__breakdown">{costBreakdown}</div>
        {showFaq && (
          <div className="payment-v3-care-plus__faq">
            <CarePlusShippingFAQ t={t} />
          </div>
        )}
      </div>
    </section>
  );
};

export default PaymentV3CarePlus;
